import React from 'react';

/**
 * Catches render/lazy-load errors (e.g. a failed code-split chunk) and shows a
 * recoverable message instead of a blank white screen.
 */
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    // Chunk load failures usually mean a stale cached shell after a new deploy.
    const msg = String(error && error.message);
    if (/ChunkLoadError|Loading chunk|Importing a module script failed/i.test(msg)) {
      // A hard reload fetches the fresh chunk manifest.
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <p className="text-foreground font-semibold">No se pudo cargar esta sección</p>
          <p className="mt-1 text-sm text-muted-foreground">
            Puede deberse a una actualización reciente o a tu conexión.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-5 px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:opacity-90"
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
